import { Component, Input, OnInit } from '@angular/core';
import { Overview } from '../../abstract/Overview';
import { DataServiceModel, Model } from '../../interfaces/Model';
import { CommonModule } from '@angular/common';
import { CLOSE, SCHEMA_OVERVIEW } from '../../shared/strings';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ServerResponse } from '../../interfaces/ServerResponse';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MainComponent } from '../../pages/main/main.component';
import { MatMenuModule } from '@angular/material/menu';
import { Neo4jCreatorComponent } from '../tab-models/neo4j-creator/neo4j-creator.component';
import { SharedService } from '../../services/shared.service';
import { INeo4jData } from '../../interfaces/INeo4jData';
import { INeo4j } from '../../interfaces/Neo4j';
import { Importer } from '../../clases/Importer';
import { ImportEnum } from '../../enums/Import';

@Component({
  selector: 'schema-overview',
  standalone: true,
  imports: [
      CommonModule,
      MatProgressSpinnerModule,
      MatButtonModule,
      MatCardModule,
      MatFormFieldModule,
      MatInputModule,
      MatIconModule,
      ReactiveFormsModule,
      MatMenuModule
    ],
  templateUrl: './schema-overview.component.html',
  styleUrl: './schema-overview.component.scss'
})
export class SchemaOverviewComponent extends Overview implements OnInit {

  SCHEMA_OVERVIEW = SCHEMA_OVERVIEW;
  CLOSE = CLOSE;

  @Input() mainComponent!: MainComponent;

  isLoading: boolean = false;

  ds_models: DataServiceModel[] = [];

  searchBox = new FormControl("");
  currentSelected!: Model;
  currentSelectedDS!: DataServiceModel;

  constructor(private beNeo4jService: BeNeo4jService, private sharedService: SharedService){super();}

  ngOnInit(): void {}

  override toggle(): void {
    super.toggle();
    if(this.isOverviewActive) this.getSchemas();
  }

  getSchemas(){
    this.isLoading = true;
    let text = this.searchBox.value;
    this.beNeo4jService.getSchemas(1, 10, text).subscribe({
      next: (res: ServerResponse<DataServiceModel>)=>{
        this.isLoading = false;
        this.ds_models = res.result;
      },
      error: (error)=>{
        this.isLoading = false;
      }
    });
  }

  onShowThisTab(){
    if(!this.currentSelected)return;
    let component = this.mainComponent.getCurrentDataView();
    if(!(component instanceof Neo4jCreatorComponent))return;
    this.beNeo4jService.getCypherById(this.currentSelected.uuid, this.currentSelected.hierarchy).subscribe({
      next: (result: any) => {
        component.executeFromMenu(result.result);
      }
    });
  }

  onShowinNewTab(){
    if(!this.currentSelected)return;
    let dataservice = this.sharedService.data_services!.find((service) => service.data_service_id === this.currentSelectedDS.string_connection);
    let neo4j_data = {
      dataService: dataservice,
      DBlabels: [],
      DBrelations: [],
      hierarchy: [],
      schemaTree: []
    } as INeo4jData;
    let neo4j = {
      connection: neo4j_data,
      name_value: "",
      containers: [],
      model_UUID: "",
      hierarchy: this.currentSelected.hierarchy
    } as INeo4j;
    this.beNeo4jService.getCypherById(this.currentSelected.uuid, this.currentSelected.hierarchy).subscribe({
      next: (result: any) => {
        let importer = new Importer(neo4j, ImportEnum.MODEL_NEW_TAB, undefined, result.result);
        this.mainComponent.onImportAction(importer);
      }
    });
  }

  setSelectedSchema(model: Model, ds: DataServiceModel){
    this.currentSelected = model;
    this.currentSelectedDS = ds;
  }

  shouldImportInThisTab(){
    if(!this.currentSelectedDS || !this.mainComponent.getCurrentDataView()) return true;
    let currentDataService = this.mainComponent.getCurrentDataView()?.savedDocument.connection.dataService.data_service_id;
    let selectedDataService = this.currentSelectedDS.string_connection;
    if(currentDataService === selectedDataService) return false;
    return true;
  }
}
